export default __webpack_public_path__ + "static/poster-a308da81fe09d1c53bd28de329bb5cc1.png";